import { OrderSigned } from '../request/models/order-signed';
import { OrderSignedInterface } from '../request/interfaces/order-signed.interface';

export const mapCommonResponse = (resp: any): boolean => {
  if (
    !resp ||
    (resp.Status !== 'OK' && resp.Status !== 'ok' && resp.Status !== '')
  ) {
    throw new Error(resp ? resp.Status : 'error.general');
  } else {
    return true;
  }
};

export const mapOrderSigned = (resp: any): OrderSignedInterface => {
  if (
    !resp ||
    (resp.Status !== 'OK' && resp.Status !== 'ok' && resp.Status !== '')
  ) {
    throw new Error(resp ? resp.Status : 'error.general');
  } else {
    return new OrderSigned(resp.XmlSignature || resp.xmlSignature || undefined);
  }
};
